export const PROVIDERS = 'providers'
export const PATIENTS = 'patients'
export const SYSADMIN = 'sysadmin'
